export const PurchaseSent = [
        {
        disabled: false,
        loading: false,
        key: "emit",
        icon: "fas fa-exchange",
        emit: "kooi:menu:order:diff_calculation",
        text: "labels.check_purchase.diff_calculation",
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-clipboard-check",
        emit: "kooi:offer:menu:pdf_validation",
        key: "validatepdf",
        text: "labels.pdf.validation.pdf_validation",
    },
    {
        disabled: false,
        loading: false,
        key: "copy",
        text: "labels.offer.menus.copy"
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-file-powerpoint",
        emit: "kooi:menu:openpdf",
        text: 'labels.order.download_po_pdf',
        data: {
            type  : "po",
        },
        display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-paper-plane",
        emit: "kooi:offer:menu:send_email",
        key: "sendmail",
        text: "labels.order.send_email",
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        key: "cancelOrder",
        icon: "fas fa-ban",
        emit: "kooi:menu:purchase:cancel",
        text: "labels.invoice.menus.cancellation"
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-clone",
        emit: "kooi:menu:copy_to_new_kooi",
        key: "emit",
        text: "labels.clone.copy_to_new_kooi"
    },
]

export const PurchaseFinalized = [
        {
        disabled: false,
        loading: false,
        key: "emit",
        icon: "fas fa-exchange",
        emit: "kooi:menu:order:diff_calculation",
        text: "labels.check_purchase.diff_calculation",
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-clipboard-check",
        emit: "kooi:offer:menu:pdf_validation",
        key: "validatepdf",
        text: "labels.pdf.validation.pdf_validation",
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-times",
        emit: "kooi:offer:menu:reject",
        key: "reject",
        text: "labels.order.reject"
    },
    {
        disabled: false,
        loading: false,
        key: "copy",
        text: "labels.offer.menus.copy"
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-file-powerpoint",
        emit: "kooi:menu:openpdf",
        text: 'labels.order.download_po_pdf',
        data: {
            type  : "po",
        },
        display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-paper-plane",
        emit: "kooi:offer:menu:send_email",
        key: "sendmail",
        text: "labels.order.send_email",
        function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
    },
    {
        disabled: false,
        loading: false,
        key: "cancelOrder",
        icon: "fas fa-ban",
        emit: "kooi:menu:purchase:cancel",
        text: "labels.invoice.menus.cancellation"
    },
    {
        disabled: false,
        loading: false,
        icon: "fas fa-clone",
        emit: "kooi:menu:copy_to_new_kooi",
        key: "emit",
        text: "labels.clone.copy_to_new_kooi"
    },


]




export const PurchaseMenu = {
            outgoing: [
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-paper-plane",
                    emit: "kooi:offer:menu:send_email",
                    key: "sendmail",
                    text: "labels.order.send_email",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    loading: false,
                    key: "sendNow",
                    text: "labels.invoice.menus.send_mail"
                },
                {
                    loading: false,
                    key: "abort",
                    icon: "fas fa-plane-slash",
                    text: "labels.invoice.menus.abort",
                    emit: "kooi:mails:menu:abort",
                },
                {
                    disabled: false,
                    loading: false,
                    key: "copy",
                    text: "labels.offer.menus.copy"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-powerpoint",
                    emit: "kooi:menu:openpdf",
                    text: 'labels.order.download_po_pdf',
                    data: {
                        type  : "po",
                    },
                    display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    key: "cancelOrder",
                    icon: "fas fa-ban",
                    emit: "kooi:menu:purchase:cancel",
                    text: "labels.invoice.menus.cancellation"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clone",
                    emit: "kooi:menu:copy_to_new_kooi",
                    key: "emit",
                    text: "labels.clone.copy_to_new_kooi"
                },
            ],
            rejected: [
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clipboard-check",
                    emit: "kooi:offer:menu:pdf_validation",
                    key: "validatepdf",
                    text: "labels.pdf.validation.pdf_validation",
                },
                {
                    disabled: false,
                    loading: false,
                    key: "copy",
                    text: "labels.offer.menus.copy"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-powerpoint",
                    emit: "kooi:menu:openpdf",
                    text: 'labels.order.download_po_pdf',
                    data: {
                        type  : "po",
                    },
                    display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clone",
                    emit: "kooi:menu:copy_to_new_kooi",
                    key: "emit",
                    text: "labels.clone.copy_to_new_kooi"
                },
            ],
            finalize: PurchaseFinalized,
            sent: PurchaseSent,
            paid: PurchaseSent,
            accepted: [
                                {
                    disabled: false,
                    loading: false,
                    key: "emit",
                    icon: "fas fa-exchange",
                    emit: "kooi:menu:order:diff_calculation",
                    text: "labels.check_purchase.diff_calculation",
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clipboard-check",
                    emit: "kooi:offer:menu:pdf_validation",
                    key: "validatepdf",
                    text: "labels.pdf.validation.pdf_validation",
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-times",
                    emit: "kooi:offer:menu:reject",
                    key: "reject",
                    text: "labels.order.reject"
                },
                {
                    disabled: false,
                    loading: false,
                    key: "copy",
                    text: "labels.offer.menus.copy"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-powerpoint",
                    emit: "kooi:menu:openpdf",
                    text: 'labels.order.download_po_pdf',
                    data: {
                        type  : "po",
                    },
                    display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-paper-plane",
                    emit: "kooi:offer:menu:send_email",
                    key: "sendmail",
                    text: "labels.order.send_email",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                // {
                //     disabled: false,
                //     loading: false,
                //     icon: "fas fa-shipping-fast",
                //     emit: "kooi:menu:create_release",
                //     key: "create_release",
                //     text: "labels.order.create_release",
                // },
                {
                    disabled: false,
                    loading: false,
                    icon_url: "/images/logos/mycroft-mc.png",
                    emit: "kooi:menu:finalize",
                    key: "finalize",
                    text: "labels.order.finalize",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "c" || item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    key: "cancelOrder",
                    icon: "fas fa-ban",
                    emit: "kooi:menu:purchase:cancel",
                    text: "labels.invoice.menus.cancellation"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clone",
                    emit: "kooi:menu:copy_to_new_kooi",
                    key: "emit",
                    text: "labels.clone.copy_to_new_kooi"
                },
            ],
            open: [
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clipboard-check",
                    emit: "kooi:offer:menu:pdf_validation",
                    key: "validatepdf",
                    text: "labels.pdf.validation.pdf_validation",
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-times",
                    emit: "kooi:offer:menu:reject",
                    key: "reject",
                    text: "labels.order.reject"
                },

                {
                    loading: false,
                    disabled: false,
                    key: "copy",
                    text: "labels.offer.menus.copy"
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-file-powerpoint",
                    emit: "kooi:menu:openpdf",
                    text: 'labels.order.download_po_pdf',
                    data: {
                        type  : "po",
                    },
                    display: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) },
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-paper-plane",
                    emit: "kooi:offer:menu:send_email",
                    key: "sendmail",
                    text: "labels.order.send_email",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
                },
                // {
                //     disabled: false,
                //     loading: false,
                //     icon: "fas fa-shipping-fast",
                //     emit: "kooi:menu:create_release",
                //     key: "create_release",
                //     text: "labels.order.create_release",
                // },
                {
                    disabled: false,
                    loading: false,
                    icon_url: "/images/logos/mycroft-mc.png",
                    emit: "kooi:menu:finalize",
                    key: "finalize",
                    text: "labels.order.finalize",
                    function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "po")) != undefined) }
                },
                {
                    disabled: false,
                    loading: false,
                    icon: "fas fa-clone",
                    emit: "kooi:menu:copy_to_new_kooi",
                    key: "emit",
                    text: "labels.clone.copy_to_new_kooi",
                    function: function (data) { return (data && data.type && data.type == "purchase_contract") }
                },
            ],
        };
